import { useCallback } from 'react';
import { useMeQuery, useUpdatePreferencesMutation } from '@platform/state/api';
import { i18n } from '@platform/i18n';
import { useAppDispatch, useAppSelector } from '@platform/state/hooks';
import { selectSession } from '@platform/state/selectors';
import { langChanged } from '@platform/state/slices/sessionSlice';
import type { Lang } from '@platform/core/types';

/** Мова інтерфейсу і її зміна: сесія (localStorage), i18next і профіль на сервері (locale разом зі схемою й закріпленими модулями). */
export function useLanguage(): [Lang, (lang: Lang) => void] {
  const dispatch = useAppDispatch();
  const session = useAppSelector(selectSession);
  const { data: me } = useMeQuery();
  const [update] = useUpdatePreferencesMutation();
  const setLang = useCallback((lang: Lang) => {
    dispatch(langChanged(lang));
    void i18n.changeLanguage(lang);
    if (me) void update({ locale: lang, colorScheme: session.colorScheme, pinnedModules: me.pinnedModules });
  }, [dispatch, me, session.colorScheme, update]);
  return [session.lang, setLang];
}
